(function () {

  function ugcCarouselInit() {

    document.addEventListener("DOMContentLoaded", function () {
      if (typeof Swiper !== 'undefined') {
        new Swiper('.ugc-carousel', {
          slidesPerView: 1,
          spaceBetween: 5,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            600: { slidesPerView: 2 },
            850: { slidesPerView: 3 },
            1200: { slidesPerView: 4 }
          }
        });
      }
    });

  }

  document.addEventListener("shopify:section:load", function (e) {
    ugcCarouselInit();
  });

  ugcCarouselInit();
})();
